import React from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import Section from '../components/Section';
import { MapPin, Phone, Mail, MessageCircle } from 'lucide-react';

const Contact = () => {
    return (
        <Layout>
            <SEO title="Contact Us" description="Get in touch with PAOZ Hope Community Church. We'd love to hear from you." />
            <div className="page-hero" style={{ backgroundImage: 'url("/Images/image copy.png")' }}>
                <div className="container">
                    <h1 className="animate-fade-in-up">Contact & Locations</h1>
                    <p className="animate-fade-in-up delay-100">We'd love to hear from you. Join us in worship across our various branches.</p>
                </div>
            </div>

            <Section>
                <div className="container grid-2">
                    {/* Contact Info */}
                    <div>
                        <h2 style={{ marginBottom: '30px' }}>Get in Touch</h2>
                        <div className="contact-details" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div className="icon-box"><Phone color="var(--primary-color)" /></div>
                                <div>
                                    <h4>Whatsapp / Call</h4>
                                    <p>+263 77 167 4344</p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div className="icon-box"><MessageCircle color="var(--primary-color)" /></div>
                                <div>
                                    <h4>WhatsApp Channel</h4>
                                    <p>
                                        <a href="https://whatsapp.com/channel/0029VaoEAODE50UoeVr9sg2w" target="_blank" rel="noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>
                                            Join our Channel
                                        </a>
                                    </p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div className="icon-box"><Mail color="var(--primary-color)" /></div>
                                <div>
                                    <h4>Email</h4>
                                    <p>Paozhcc@gmail.com</p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div className="icon-box"><MapPin color="var(--primary-color)" /></div>
                                <div>
                                    <h4>Main Address</h4>
                                    <p>10 Good Hope Westgate, Harare, Zimbabwe</p>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* Location Map */}
                    <div>
                        <h2 style={{ marginBottom: '30px' }}>Our Location</h2>
                        <div style={{ height: '400px', borderRadius: '15px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}>
                            <iframe
                                src="https://maps.google.com/maps?q=Cornelius%20Hope%20Academy%20Secondary%20School,%2010%20Goodhope%20Road%20Westgate%20Harare&t=&z=15&ie=UTF8&iwloc=&output=embed"
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                title="HCC Westgate Location"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </Section>
        </Layout>
    );
};

export default Contact;
